export enum ProjectPerson {
  CLIENT_RESPONSIBLE_FOR_PROJECT = 'CLIENT_RESPONSIBLE_FOR_PROJECT',
  EMPLOYEE_RESPONSIBLE_FOR_PROJECT = 'EMPLOYEE_RESPONSIBLE_FOR_PROJECT',
}
